module.exports = __webpack_public_path__ + "img/Analize.ecb32480.jpg";